import React, { useState, useRef, useCallback, useMemo, useEffect } from 'react';
import '../app.css';
import images from "./images";
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

function useOutsideAlerter(ref, setShowTemplateNav) {
    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                setShowTemplateNav(false)
            }
        }
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);
}


export default (props) => {
    const { setShowTemplateNav } = props
    const wrapperRef = useRef(null);
    useOutsideAlerter(wrapperRef, setShowTemplateNav);
    const onDragStart = (event, nodeType) => {
        event.dataTransfer.setData('application/reactflow', nodeType);
        event.dataTransfer.effectAllowed = 'move';
    };

    return (
        <div className="template-header" ref={wrapperRef}>
            <IconButton
                aria-label="close"
                onClick={() => setShowTemplateNav(false)}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>
            <div style={{ display: 'flex' }} >
                <Tippy className="tooltip" content={<span>Drag <b>Prometheus with Thanos Receiver</b> mode flow graph to the canvas on the bottom</span>}>
                    <div className="grabbable"
                        style={{ display: 'grid', marginTop: 20, justifyItems: 'center', textAlign: 'center' }} onDragStart={(event) => onDragStart(event, 'templateReceiver')} draggable>
                        <img
                            src={images.FlowChart1}
                            height="100px"
                            width={100}
                            className="grabbable-image"
                        />
                        <span style={{ fontSize: 13, marginTop: 3, width: 185 }}>
                            Prometheus with Thanos <b>Receiver</b> mode</span>

                    </div>
                </Tippy>
                <Tippy className="tooltip" content={<span>Drag <b>Prometheus with Thanos Sidecar</b> mode flow graph to the canvas on the bottom</span>}>

                    <div style={{ display: 'grid', marginTop: 20, justifyItems: 'center', textAlign: 'center' }}
                        onDragStart={(event) => onDragStart(event, 'templateSidecar')} draggable
                        className="grabbable"
                    >
                        <img
                            src={images.FlowChart1}
                            height="100px"
                            width={100}
                            className="grabbable-image"

                        />
                        <span style={{ fontSize: 13, marginTop: 3, width: 185 }}>
                            Prometheus with Thanos <b>Sidecar</b> mode</span>

                    </div>
                </Tippy>

            </div>
        </div>
    );
};
